var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1982_3080",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1982_3080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17C10.4444 17 9.06944 16.5556 7.875 15.6667C6.68056 14.7778 5.84722 13.6389 5.375 12.25H3L3 10.75H5.04167C5.01389 10.5556 5 10.3333 5 10.0833C5 9.83333 5.01389 9.55555 5.04167 9.25H3V7.75H5.375C5.84722 6.36111 6.68056 5.22222 7.875 4.33333C9.06944 3.44444 10.4444 3 12 3C12.9861 3 13.9062 3.1875 14.7604 3.5625C15.6146 3.9375 16.3611 4.45139 17 5.10417L15.9375 6.16667C15.4375 5.65278 14.8507 5.24653 14.1771 4.94792C13.5035 4.64931 12.7778 4.5 12 4.5C10.875 4.5 9.86458 4.80208 8.96875 5.40625C8.07292 6.01042 7.40972 6.79167 6.97917 7.75H12V9.25H6.54167C6.51389 9.40278 6.49653 9.60764 6.48958 9.86458C6.48264 10.1215 6.5 10.4167 6.54167 10.75H12V12.25H6.97917C7.40972 13.2083 8.07292 13.9896 8.96875 14.5937C9.86458 15.1979 10.875 15.5 12 15.5C12.7778 15.5 13.5035 15.3507 14.1771 15.0521C14.8507 14.7535 15.4375 14.3472 15.9375 13.8333L17 14.8958C16.3611 15.5486 15.6146 16.0625 14.7604 16.4375C13.9062 16.8125 12.9861 17 12 17Z",
    fill: "#5A348C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.49466ffb3b483ae47ab951ebb33cbd86.svg";
export { ForwardRef as ReactComponent };